﻿﻿export interface ITicketFile {
    id: number;
    fileName: string;
    fileIndex: number;
}
